import { CollectionStatsuType, LearnStatType } from "../../../Constant";
import { NAME_DEV_SET } from '../../../function/NameDevSetModel';
import { ALM_KIND_SET, ALM_SMM_DAT } from '../../molecules/Grid/AlarmGrid';

export type IOT_SET = {
  IMSI_NO: string;
  DEV_INDEX: string;
  RUN_FLG: string;
  LOG_SEC: string;
  LOG_MIN: string;
  LOG_HOUR: string;
  LOG_DAY: string;
  LOG_MONTH: string;
  LOG_DOW: string;
  HEALTH_SEC: string;
  HEALTH_MIN: string;
  HEALTH_HOUR: string;
  HEALTH_DAY: string;
  HEALTH_MONTH: string;
  HEALTH_DOW: string;
  ERRORLOG_SEC: string;
  ERRORLOG_MIN: string;
  ERRORLOG_HOUR: string;
  ERRORLOG_DAY: string;
  ERRORLOG_MONTH: string;
  ERRORLOG_FLG: CollectionStatsuType;
  ERRORLOG_DOW: string;
  MOBILE_BATTERY: number;
  LITHIUM_BATTERY: number;
  LOG_NEW?: Date;
  LOG_NEXT?: Date;
  HEALTH_NEW?: Date;
  HEALTH_NEXT?: Date;
  ERRORLOG_NEW?: Date;
  ERRORLOG_NEXT?: Date;
  SET_VER: string;
  HEALTH_FLG: CollectionStatsuType;
  HEALTH_CODE: string;
  GET_FLG?: CollectionStatsuType;
  IOT_SET_FLG?: number;
  STUDY_FLG?: number;
  MEMO: string;
  STUDY_NEW?: Date;
  STUDY_NEXT?: Date;
  STUDY_COUNT?: number;
  STUDY_STATUS?: number;
  ALM_KIND?: number;
  LOCAL_VER: string;
  AUTO_RETRY_TIME?: Date;
  AUTO_RETRY_COUNT?: number;
  RECOLLECTION_TIME?:Date;
  RECOLLECTION_COUNT?:number;
  RECOLLECTION_STOP_FLG?:number;
}


export type V_IOTBOX_DEV_LIST = {
  IMSI_NO: string;
  STUDY_FLG?: number;
  DEV_INDEX: number;
  DEV_NO: string;
  DEV_NAME: string;
  IOT_SET_FLG?: number;
  LOG_NEW?: Date;
  LOG_NEXT?: Date;
  GET_FLG?: CollectionStatsuType;
  IOT_SET: IOT_SET;
  NAME_DEV_SET: NAME_DEV_SET;
  IS_MANUAL_COLRECT: boolean;
  IS_STUDY_CHECK: boolean;
  IS_STUDY_CANCEL_CHECK: boolean;
  IS_STUDY_CANCEL_RUN: boolean;
  SENSOR_STATUS: number;
  //以下DEV_STATUS
  COL_MODE?: number;
  STATUS?: number;
  LEARN_STAT?: LearnStatType;
};
export type IoTBoxDeviceLists = {
  //V_IOTBOX_DEV_LIST_DISP: V_IOTBOX_DEV_LIST;
  V_IOTBOX_DEV_LISTS: V_IOTBOX_DEV_LIST[];
};

export type IotBoxAlarmData = {
  ALM_SMM_DAT: ALM_SMM_DAT;
  ALM_KIND_SET: ALM_KIND_SET;
};

/**
 * IoTBox機器一覧取得
 * @returns
 */
export const GetIoTBoxDeviceLists = (): Promise<IoTBoxDeviceLists> => {
  return new Promise((resolve, reject) => {
    const url = 'api/IoTBoxDeviceList?';
    var param = "";
    fetch(`${url}${param}`)
      .then((res) => res.json())
      .then((result: IoTBoxDeviceLists) => {
        if (deviceListValidate(result)) {
          //機器INDEXソート
          const sortedList = result.V_IOTBOX_DEV_LISTS.sort(function (a, b) {
            return a.DEV_INDEX - b.DEV_INDEX;
          });
          result.V_IOTBOX_DEV_LISTS = sortedList;
          console.debug(['Get result Data', 'api/IoTBoxDeviceList?', result]);
          resolve(result);
        } else {
          reject('Invalidate response');
        }
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

const deviceListValidate = (data: IoTBoxDeviceLists) => {
  if (data == undefined) return false;
  return true;
};

/**
 * IoTBox　データ収集(手動)開始
 * @param imsiNo
 * @returns
 */
export const SetInstructManualCollection = (imsiNo: string): Promise<number> => {
  //console.debug(['data', imsiNo]);
  return new Promise((resolve, reject) => {
    fetch('api/IoTBoxSetting/InstructManualCollection', {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(imsiNo),
    })
      .then((res) => {
        console.debug(['res', res]);
        resolve(res.status);
      })
      .catch(err => {
        console.debug(['reason', err]);
        reject(err);
      });
  });
}

/**
 * IoTBox　学習モード開始
 * @param imsiNo
 * @returns
 */
export const SetStudyCollection = (imsiNo: string): Promise<number> => {
  return new Promise((resolve, reject) => {
    fetch('api/IoTBoxSetting/StudyCollection', {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(imsiNo),
    })
      .then((res) => {
        console.debug(['res', res]);
        resolve(res.status);
      })
      .catch(err => {
        console.debug(['reason', err]);
        reject(err);
      });
  });
}
/**
 * 学習処理　キャンセル
 * @param imsiNo
 * @returns
 */
export const cancelStudyCollection = (imsiNo: string): Promise<number> => {
  return new Promise((resolve, reject) => {
    fetch('api/IoTBoxSetting/CancelStudyCollection', {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(imsiNo),
    })
      .then((res) => res.json())
      .then((res) => {
        console.debug(['res', res])
        resolve(res);
      })
      .catch(err => {
        console.debug(['reason', err]);
        reject(err);
      })

  })

}

/**
 * IotBoxエラー情報取得
 * @returns
 */
export const GetIoTBoxErrorList = (imsiNo: string): Promise<IotBoxAlarmData[]> => {
  return new Promise((resolve, reject) => {
    const url = 'api/AlarmSummary/IoTAlarmList?';
    var param = `imsiNo=${imsiNo}`;
    fetch(`${url}${param}`)
      .then((res) => res.json())
      .then((result: IotBoxAlarmData[]) => {
        console.debug(`${url}${param}`);
        console.debug(['GetIoTBoxErrorList result', result]);
        resolve(result);
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

export const GetStatuserrorList = (imsiNo: string): Promise<IotBoxAlarmData[]> => {
  return new Promise((resolve, reject) => {
    const url = 'api/AlarmSummary/StatusAlarmList?'
    var param = `imsiNo=${imsiNo}`;
    fetch(`${url}${param}`)
      .then((res) => res.json())
      .then((result: IotBoxAlarmData[]) => {
        console.debug(`${url}${param}`);
        console.debug(['GetStatuserrorList result', result]);
        resolve(result);
      },
        (error) => {
          console.log(error);
          reject(error);
        });
  });
}

/**
 * 再収集処理の停止処理
 * @param imsiNo 
 * @returns 
 */
export const StopRecollection = (imsiNo: string): Promise<number> =>{
  return new Promise((resolve, reject) => {
    fetch('api/IoTBoxSetting/StopRecollection', {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(imsiNo),
    })
      .then((res) => res.json())
      .then((res) => {
        console.debug(['res', res])
        resolve(res);
      })
      .catch(err => {
        console.debug(['reason', err]);
        reject(err);
      })
  })
}
